export default function About() {
    return (
        <div class = 'content' id = 'about'>
            <div class = 'photo'>
                <img src = 'Qian.jpeg' alt = 'Founder' />
            </div>
            <h2>Who am I?</h2>
            <p>
                I have a disability, mental health disorder, and I want to do something nice outside of
                my comfort zone to help people to help me feel god inside. God has supported me by helping me
                build this company. I have been through quite a lot, and it's not that easy. It is a difficult world.
                But when you get help, support, and resources it makes it better to live -- it makes it easier
                to live. You don't feel any negative feelings. For me, I love this job, I love my family, I love
                my supports because I'm still alive, I'm still here, and I seek help because God has a plan for
                me. I don't know what that plan is, but it will be a good plan. That is why I want to create This
                company. I want to help people, and provide crisis lines and help people know that they are not alone.
            </p>
            <h2>What is this company all about?</h2>
            <p>
                This company is about providing resources to help you go through difficult times.
                I provide advocacy and peer support to help you go through the hard times.
            </p>
            <h2>Why I started this company</h2>
            <p>
                I started this company because I've gone through hard, difficult times in my life and 
                I want to share that with people by providing more resources, hardlines, and anything 
                that helps relieve the difficulties and helps them o through the hard times without 
                being alone. I have a disability and mental health challenges,and some days are really
                difficult. That's why I started this company; to help other people that have troubles
                with mental health, learning their disability, and/or going through hard times.
            </p>
        </div>
    );
}